import React, { useState, useEffect } from 'react';
import { CalendarDays, Clock } from 'lucide-react';

// Relógio + data ao vivo, SEMPRE no fuso de New York (America/New_York).
// Fundo branco, em uma linha própria para não sobrepor os ícones no mobile.
const NyClock = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const opts = { timeZone: 'America/New_York' };
  const weekday = now.toLocaleDateString('en-US', { ...opts, weekday: 'short' });
  const date = now.toLocaleDateString('en-US', { ...opts, month: '2-digit', day: '2-digit', year: 'numeric' });
  const time = now.toLocaleTimeString('en-US', { ...opts, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });

  return (
    <div
      data-testid="ny-clock"
      className="inline-flex items-center gap-1.5 rounded-full bg-white border border-slate-200 px-2.5 py-1 shadow-sm max-w-full"
      title="Data e hora do sistema (New York)"
    >
      <CalendarDays className="h-3.5 w-3.5 text-teal-500 flex-shrink-0" />
      <span className="text-[11px] sm:text-xs font-medium text-slate-700 whitespace-nowrap" data-testid="ny-clock-date">
        {weekday} {date}
      </span>
      <span className="mx-0.5 text-slate-300">·</span>
      <Clock className="h-3.5 w-3.5 text-amber-500 flex-shrink-0" />
      <span className="text-[11px] sm:text-xs font-mono tabular-nums text-slate-800 whitespace-nowrap" data-testid="ny-clock-time">
        {time}
      </span>
      <span className="ml-0.5 text-[10px] font-bold text-teal-600 whitespace-nowrap">NY</span>
    </div>
  );
};

export default NyClock;
